module.exports = __webpack_public_path__ + "img/package.d5c9fb9b.png";